function init() {
    document.querySelectorAll(".wp-block-video video").forEach((video) => {
        // Create Play Button
        const playButton = document.createElement("span");
        playButton.classList.add("custom-play-button");
        playButton.innerHTML = '<img src="/wp-content/themes/summit/dist/images/play-icon.png" alt="play video" />';

        // Wrap video inside a container for positioning
        const wrapper = document.createElement("div");
        wrapper.classList.add("custom-video-wrapper");
        video.parentNode.insertBefore(wrapper, video);
        wrapper.appendChild(video);
        wrapper.appendChild(playButton);

        // Hide default controls initially
        video.removeAttribute("controls");

        // Play Video on Click
        playButton.addEventListener("click", function () {
            video.play();
            video.setAttribute("controls", "true"); // Show controls after play
            playButton.style.display = "none"; // Hide play button
        });

        // Hide Play Button When Video Starts
        video.addEventListener("play", function () {
            playButton.style.display = "none";
        });

        // Handle clicking the .is-style-video-play-button a button
        document.querySelectorAll(".is-style-video-play-button a").forEach((button) => {
            button.addEventListener("click", function (event) {
                event.preventDefault(); // Prevent any default link behavior

                // Get all videos on the page
                const videos = document.querySelectorAll(".wp-block-video video");
                if (videos.length === 0) return; // No videos found, exit

                let targetVideo = null;

                // Find the first video below the button
                for (let video of videos) {
                    if (video.getBoundingClientRect().top > window.scrollY) {
                        targetVideo = video;
                        break;
                    }
                }

                // If no video is found below, use the last video on the page
                if (!targetVideo) {
                    targetVideo = videos[videos.length - 1];
                }

                // Scroll to the video smoothly
                targetVideo.scrollIntoView({ behavior: "smooth", block: "center" });

                // Wait for scrolling to finish, then play the video
                setTimeout(() => {
                    const playButton = targetVideo.closest(".custom-video-wrapper")?.querySelector(".custom-play-button");
                    if (playButton) {
                        playButton.click(); // Simulate clicking the play button
                    }
                }, 500); // Delay ensures scroll finishes before playing
            });
        });

    });
}

export { init as default };